import * as constants from './actions';
import { GO_NEXT_ACTION } from '../Widget/actions';
import { getInitiatedTime } from '../../utils/actionTiming';

const initialState = {
    actionInitiated: false,
    answerId: null,
    isSubmitting: false,
    isAnswered: false,
    result: null,
    userAnswer: null,
    correctValue: null
};

export default function radialSlider(state = initialState, { type, payload }) {
    switch (type) {
        case GO_NEXT_ACTION:
            return {
                ...state,
                ...initialState
            };
        case constants.RADIAL_SLIDER_INITIATED:
            return {
                ...state,
                actionInitiated: true,
                actionIdentifier: [payload],
                ...getInitiatedTime(payload, state)
            };
        case constants.RADIAL_SLIDER_ANSWER_SUBMITTING:
            const { isSubmitting, userAnswer } = payload;
            return {
                ...state,
                isSubmitting,
                userAnswer
            };
        case constants.RADIAL_SLIDER_SUCCESS:
            const {
                answerId,
                correctValue,
                counter,
                result,
                feedbackCustomVariableCalc
            } = payload.data;
            const returnedData = {
                ...state,
                answerId,
                counter,
                feedbackCustomVariableCalc,
                isAnswered: true,
                result
            };
            if (correctValue !== undefined) {
                returnedData.correctValue = correctValue;
            }
            return returnedData;
        default:
            return state;
    }
}
